(function () {
  const moneyFormat = (window.theme && window.theme.moneyFormat) || "Rs. {{amount}}";
  const routes = (window.theme && window.theme.routes) || {
    cartAdd: "/cart/add",
    cartJs: "/cart.js",
    cartUpdate: "/cart/update.js",
    checkout: "/checkout"
  };

  function formatMoney(cents) {
    const value = (Number(cents) / 100).toFixed(2);
    if (typeof moneyFormat === "string" && moneyFormat.indexOf("{{amount}}") !== -1) {
      return moneyFormat.replace("{{amount}}", value).replace("{{amount_no_decimals}}", String(Math.round(cents / 100)));
    }
    return "Rs. " + value;
  }

  async function fetchCart() {
    const res = await fetch(routes.cartJs || "/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  function cartEndpoint(path) {
    const base = path || "";
    return base.endsWith(".js") ? base : base + ".js";
  }

  async function clearCart() {
    const res = await fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" }
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || "Could not reset cart");
    }
    return res.json();
  }

  async function addToCart(id, quantity, properties) {
    const payload = { items: [{ id: Number(id), quantity: quantity || 1 }] };
    if (properties) payload.items[0].properties = properties;
    const res = await fetch(cartEndpoint(routes.cartAdd || "/cart/add"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || err.message || "Could not add to cart");
    }
    return res.json();
  }

  async function updateCart(data) {
    const res = await fetch(cartEndpoint(routes.cartUpdate || "/cart/update"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(data)
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || err.message || "Could not update cart");
    }
    return res.json();
  }

  function updateCartCount(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count || 0;
    });
  }

  function renderDrawer(cart) {
    const root = document.querySelector("[data-cart-drawer]");
    if (!root) return;
    const itemsEl = root.querySelector("[data-cart-items]");
    const emptyEl = root.querySelector("[data-cart-empty]");
    const footerEl = root.querySelector("[data-cart-footer]");
    const subtotalEl = root.querySelector("[data-cart-subtotal]");
    if (!cart || !cart.items || cart.items.length === 0) {
      if (itemsEl) itemsEl.innerHTML = "";
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footerEl) footerEl.hidden = false;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(function (item) {
        return (
          '<article class="drawer-item">' +
            '<img src="' + (item.image || "") + '" alt="">' +
            "<div><strong>" + item.product_title + "</strong>" +
            "<p>" + (item.variant_title || "") + "</p>" +
            "<p>" + item.quantity + " × " + formatMoney(item.final_price) + "</p></div>" +
          "</article>"
        );
      }).join("");
    }
  }

  function openDrawer() {
    const root = document.querySelector("[data-cart-drawer]");
    if (root) root.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    const root = document.querySelector("[data-cart-drawer]");
    if (root) root.hidden = true;
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    const toggle = e.target.closest("[data-menu-toggle]");
    if (toggle) {
      const nav = document.querySelector("[data-mobile-nav]");
      if (nav) {
        nav.hidden = !nav.hidden;
        document.body.style.overflow = nav.hidden ? "" : "hidden";
      }
    }
    const mobileNav = document.querySelector("[data-mobile-nav]");
    if (mobileNav && !mobileNav.hidden && e.target === mobileNav) {
      mobileNav.hidden = true;
      document.body.style.overflow = "";
    }
    if (e.target.closest("[data-cart-toggle]")) {
      e.preventDefault();
      fetchCart().then(function (cart) {
        renderDrawer(cart);
        openDrawer();
      });
    }
    if (e.target.closest("[data-cart-close]")) closeDrawer();

    const quick = e.target.closest("[data-quick-add]");
    if (quick) {
      e.preventDefault();
      e.stopPropagation();
      const btn = quick;
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding...";
      addToCart(btn.dataset.variantId, 1)
        .then(fetchCart)
        .then(function (cart) {
          updateCartCount(cart);
          renderDrawer(cart);
          if (window.theme && window.theme.cartDrawer) openDrawer();
          btn.textContent = "Added ✓";
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1000);
        })
        .catch(function (err) {
          alert(err.message);
          btn.textContent = original;
          btn.disabled = false;
        });
    }
  });

  /* Mobile category horizontal scroll feels smoother with drag */
  document.querySelectorAll("[data-category-scroll]").forEach(function (track) {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    track.addEventListener("pointerdown", function (e) {
      if (window.matchMedia("(max-width: 990px)").matches === false) return;
      isDown = true;
      startX = e.clientX;
      scrollLeft = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener("pointermove", function (e) {
      if (!isDown) return;
      track.scrollLeft = scrollLeft - (e.clientX - startX);
    });
    track.addEventListener("pointerup", function () { isDown = false; });
    track.addEventListener("pointercancel", function () { isDown = false; });
  });

  window.MyStoreCart = {
    formatMoney: formatMoney,
    fetchCart: fetchCart,
    clearCart: clearCart,
    addToCart: addToCart,
    updateCart: updateCart,
    updateCartCount: updateCartCount,
    renderDrawer: renderDrawer,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer
  };
})();
